import React, { useContext } from 'react';
import styles from './style.module.css';
import MobileContext from 'context/MobileContext';
import { Dialog } from '@material-ui/core';
import { crossIcon } from 'assets/newIcons';

const TnCPopUp = ({
  open,
  onClose,
  popupDetails,
  termsAgreementValues,
  setOpenTncPopUp,
}) => {
  const isMobile = useContext(MobileContext);

  const handleClose = () => {
    localStorage.setItem('tncPopupClosed', 'true');
    setOpenTncPopUp(false);
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div
          className={`${
            !termsAgreementValues?.isdocumentcrossiconenable
              ? styles.container
              : styles.newContainer
          } ${isMobile ? styles.mobile : ''}`}
        >
          {termsAgreementValues?.isdocumentcrossiconenable ? (
            <img
              src={crossIcon}
              alt="icon"
              className={styles.popoverLogo}
              onClick={handleClose}
            />
          ) : (
            ''
          )}
          <p className={styles.heading}>{popupDetails?.tearmAndConditionHeader}</p>

          <div
            className={`${styles.scroll} ${isMobile ? styles.mobile : ''}`}
            style={{
              maxHeight: '350px',
              overflowY: 'auto',
              padding: '10px',
            }}
          >
            <p
              className={`${styles.card} ${isMobile ? styles.mobile : ''}`}
              dangerouslySetInnerHTML={{
                __html: popupDetails?.tearmAndConditionText,
              }}
            />
          </div>
          <button onClick={onClose} className={styles.button}>
            {popupDetails?.tearmAndConditionButtonText}
          </button>
        </div>
      </Dialog>
    </>
  );
};

export default TnCPopUp;
